import React from "react";
import { Typography, makeStyles, Container, Button } from "@material-ui/core";
import { lighten } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import Link from "../Link";
import { N1Icon } from "./icons/N1Icon";
import { M1Icon } from "./icons/M1Icon.js";
import { N23Icon } from "./icons/N23Icon.js";

const useStyles = makeStyles((theme) => ({
  heading: {
    marginBottom: "64px",
  },
  root: {
    padding: "4rem 1rem",
    textAlign: "center",
    backgroundColor: "#fff",
  },
  grid: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      gap: "2.5rem",
    },
  },
  item: {
    width: "190px",
    minWidth: "140px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    textAlign: "center",
  },
  title: {
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: 1.4,
    marginBottom: "1rem",
    minHeight: "48px",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
      marginBottom: "0.5rem",
    },
  },
  price: {
    fontSize: "18px",
    fontWeight: 700,
    marginTop: "0.75rem",
    textAlign: "center",
  },
  icon: {
    fontSize: "3.5rem",
  },
  btn: {
    color: theme.palette.primary.light,
    background: theme.palette.primary.main,
    marginTop: "32px",
    boxShadow: "none",
    transition: "0.5s",
    "&:hover": {
      background: lighten(theme.palette.primary.main, 0.2),
    },
  },
}));

const Dienstleistungen = () => {
  const classes = useStyles();
  const prices = useSelector((state) => state.prices.items);

  const year = new Date().getFullYear();

  // ✅ only the types you really support
  const titleMap = {
    m1: "E-Auto (M1)",
    n1: "Leichtes E-Nutzfahrzeug (N1)",
    n2: "Schweres E-Nutzfahrzeug (N2)",
  };

  const iconMap = {
    m1: <M1Icon className={classes.icon} />,
    n1: <N1Icon className={classes.icon} />,
    n2: <N23Icon className={classes.icon} />,
  };

  const newCustomerBonusPriceMap = {
    m1: 50,
    n1: 50,
    n2: 100,
  };

  // formats 2650 -> 2.650 (also safe if price is "2650 €")
  const formatNumberDE = (value) => {
    const raw = String(value ?? "");
    const digitsOnly = raw.replace(/[^\d]/g, "");
    if (!digitsOnly) return raw;
    return new Intl.NumberFormat("de-DE").format(Number(digitsOnly));
  };

  // ✅ only show m1, n1, n2
  const visibleTypes = ["m1", "n1", "n2"];

  return (
    <div className={classes.root}>
      <Container>
        <Typography variant="h2" className={classes.heading}>
          Unsere Preise {year}
        </Typography>

        <div className={classes.grid}>
          {(prices || [])
            .filter((p) => visibleTypes.includes(p.type))
            .map((p) => (
              <div className={classes.item} key={p.type}>
                <Typography className={classes.title}>
                  {titleMap[p.type]}
                </Typography>

                {iconMap[p.type]}

                <Typography
                  className={classes.price}
                  style={{ fontSize: "16px", fontWeight: 700 }}
                >
                  {formatNumberDE(p.price)} € pro Jahr
                </Typography>

                {newCustomerBonusPriceMap[p.type] && (
                  <Typography
                    style={{
                      fontSize: "14px",
                      fontWeight: 600,
                      marginTop: "0.75rem",
                      color: "#2e7d32",
                    }}
                  >
                    + Neukundenbonus*:{" "}
                    {formatNumberDE(newCustomerBonusPriceMap[p.type])} €
                  </Typography>
                )}
              </div>
            ))}
        </div>

        <Typography
          style={{
            marginTop: "2.5rem",
            fontSize: "13px",
            color: "#777",
          }}
        >
          *Der Neukundenbonus gilt nur für das erste eingereichte Fahrzeug und
          nur für Neukunden.
        </Typography>

        <Link href="/register" underline="none">
          <Button variant="contained" size="large" className={classes.btn}>
            Jetzt registrieren
          </Button>
        </Link>
        <div id="ablauf"></div>
      </Container>
    </div>
  );
};

export default Dienstleistungen;
